import React from 'react'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { Breadcrumbs } from '../breadcrumbs'
import { PageheaderActions } from './pageheaderActions'
import { PageheaderImage } from './pageheaderImage'
import { PageheaderSearchForm } from './pageheaderSearchForm'
import { PageHeaderProps } from './types'

export const PageheaderZEG = ({
  title,
  introduction,
  primaryAction,
  secondaryAction,
  image,
  breadcrumbs,
  extraClasses,
  kind,
}: PageHeaderProps) => {
  const { inView, ref } = useInView({ threshold: 0.1 })
  const isHome = kind == 'home'
  const isNews = kind == 'news'
  return (
    <>
      {breadcrumbs && !isHome && <Breadcrumbs breadcrumbs={breadcrumbs} />}

      <header ref={ref} className={cn(`pageheader ph ph--${image ? 'image' : 'text'}`, isHome && 'ph--home', isNews && 'ph--news', inView && 'inview', extraClasses)}>
        <div className='ph__outer'>
          <div className="ph__inner ls-container ls-gutter gridsys--columns">
            <div className="ph__text">
              {title && <h1 className={cn('ph__title', isHome ? 'title--2xl' : 'title--xl')}>{title}</h1>}

              {introduction &&
                <p className="ph__intro text--xl">{introduction}</p>
              }

              {isHome && <PageheaderSearchForm />}

              <PageheaderActions primaryAction={primaryAction} secondaryAction={secondaryAction} isHome={isHome} />
            </div>

            <PageheaderImage image={image} isHome={isHome} />
          </div>
        </div>

        <svg className="ph__shape" width="1920" height="150" viewBox="0 0 1920 150" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0.460938C463.481 118.582 961.528 171.056 1314.51 142.258C1551.54 122.925 1752.57 77.73 1920 13.3613V0H0V0.460938Z" fill="#012169"/></svg>

        <svg className="hh__blob" width="619" height="751" viewBox="0 0 619 751" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M147.145 217.303C405.098 239.578 331.809 -0.789335 468.176 1.01005C516.627 1.64181 588.941 102.317 610.45 259.181C637.778 458.459 586.559 550.645 519.621 575.683C374.384 629.996 334.579 412.061 230.487 487.796C129.397 561.327 167.105 745.779 92.0906 749.698C38.1121 752.525 12.636 602.171 4.58482 475.664C-2.67612 361.628 -14.635 203.331 147.145 217.303Z" stroke="#346DAC" stroke-width="2" stroke-miterlimit="10"/>
        </svg>
      </header>
    </>
  )
}
